/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import CPSheetProblemAnalyticsDash from "../../../../components/CPSheet/Analytics/Problem";
import Navbar from "../../../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../../../constants/routes";

const CPSheetProblemAnalytics = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);
  useEffect(() => {
    if (!userConfig?.cpSheetAnalytics?.hasProblemDashboardAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <CPSheetProblemAnalyticsDash adminConfig={userConfig} ROOT_URL={ROOT_URL} />
    </>
  );
};

export default CPSheetProblemAnalytics;
